import Swiper from 'swiper';
import { Navigation, Controller } from 'swiper/modules';
import 'swiper/css/bundle';

// Initialisation Swiper standard
const carousels = document.querySelectorAll('.swiper');

if (carousels.length > 0) {
	carousels.forEach((carousel) => {
		const nextBtn = carousel.querySelector('.swiper-button-next');
		const prevBtn = carousel.querySelector('.swiper-button-prev');

		const swiperInstance = new Swiper(carousel, {
			modules: [Navigation],
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			spaceBetween: -85,
			freeMode: true,
			loop: false,
			slidesPerView: 'auto',
			grabCursor: true
		});

		// 🎯 Gestion des filtres spécifiques à ce carrousel
		const filterWrapper = carousel.closest('.carousel'); // ou adapte selon la structure
		const buttons = filterWrapper?.querySelectorAll('.carousel__filters button');
		const slides = carousel.querySelectorAll('.swiper-slide');

		if (buttons && buttons.length > 0) {
			buttons.forEach(btn => {
				btn.addEventListener('click', () => {
					const filter = btn.getAttribute('data-crfilter');

					// Retirer la classe active de tous les boutons
					buttons.forEach(b => b.classList.remove('active'));
					btn.classList.add('active');

					// Filtrage des slides
					slides.forEach(slide => {
						if (filter === 'all' || slide.dataset.crfilter === filter) {
							slide.style.display = '';
						} else {
							slide.style.display = 'none';
						}
					});

					// Mise à jour Swiper
					swiperInstance.update();

					// Forcer la mise à jour de la classe active
					swiperInstance.slides.forEach(s => s.classList.remove('is-active'));
					const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
					if (activeSlide) {
						activeSlide.classList.add('is-active');
					}
				});
			});
		}
	});
} else {
	console.log('Aucun carrousel .swiper trouvé sur la page.');
}

const alternateCarousels = document.querySelectorAll('.alternate--carousel');

if (alternateCarousels.length > 0) {
	console.log('alternateCarousels found: ', alternateCarousels.length);

	alternateCarousels.forEach((alternateCarousel) => {
		const altSwiperContainer = alternateCarousel.querySelector('.container-full');
		const altNextBtn = alternateCarousel.querySelector('.swiper-button-next');
		const altPrevBtn = alternateCarousel.querySelector('.swiper-button-prev');

		new Swiper(altSwiperContainer, {
			modules: [Navigation],
			navigation: {
				nextEl: altNextBtn,
				prevEl: altPrevBtn,
			},
			loop: false,
			slidesPerView: 1,
			grabCursor: true
		});
	})
}

/**
 * Synchronisation des deux carousels de la section "Intro et Carrousel"
 * - La partie avec le titre de la slide dans la zone bleue
 * - Et la partie avec le texte, les boutons et l'image
 */
const icHeadCarousels = document.querySelectorAll('.big-carousel__intro');
const icCarousels = document.querySelectorAll('.big-carousel__content');

if (icHeadCarousels.length > 0 && icCarousels.length > 0) {
    console.log('icHeadCarousels found:', icHeadCarousels.length);
    console.log('icCarousels found:', icCarousels.length);

    icHeadCarousels.forEach((icHeadCarousel, index) => {
        const icHeadSwiperContainer = icHeadCarousel.querySelector('.big-carousel__intro-carousel');
        const icCarousel = icCarousels[index]; // Associe les deux carousels par index
        const icSwiperContainer = icCarousel.querySelector('.big-carousel__content-carousel');
        const icNextBtn = icCarousel.querySelector('.swiper-button-next');
        const icPrevBtn = icCarousel.querySelector('.swiper-button-prev');

        // Crée l'instance du slider intro
        const icHeadSwiper = new Swiper(icHeadSwiperContainer, {
			modules: [Controller],
            allowTouchMove: false,
            spaceBetween: 100,
            loop: true,
            slidesPerView: 1,
            grabCursor: true
        });

        // Crée l'instance du slider content et le synchronise avec le slider intro
        const icContentSwiper = new Swiper(icSwiperContainer, {
            modules: [Navigation, Controller],
            navigation: {
                nextEl: icNextBtn,
                prevEl: icPrevBtn,
            },
            spaceBetween: 100,
            loop: true,
            slidesPerView: 1,
            grabCursor: true,
            controller: {
                control: icHeadSwiper,
            },
        });

        // Optionnel : synchronisation bidirectionnelle
        icHeadSwiper.controller.control = icContentSwiper;
    });
}